import { CmsTaxonomy } from '@fcom/core-api/interfaces/cms-interface';
import { MonitoringLogger } from '@fcom/core/services/monitoring/monitoring-logger';

const HEADER_LEVEL = 'header-level';
const FONT_HEADING = 'font-heading';

export const getHeaderLevel = (
  subjectTaxonomyTags: CmsTaxonomy[],
  contentId?: number,
  monitoringLogger?: MonitoringLogger
): number | undefined => {
  const levelTags: CmsTaxonomy[] = subjectTaxonomyTags?.filter((tag): boolean => tag.startsWith(HEADER_LEVEL));
  if (levelTags?.length > 1 && monitoringLogger) {
    monitoringLogger.error('Each CMS content should have only one header-level subjectTaxonomyTag.', contentId);
  }
  return levelTags && levelTags.length > 0 ? Number(levelTags[0].substring(HEADER_LEVEL.length + 1)) : undefined;
};

export const getFontLevel = (subjectTaxonomyTags: CmsTaxonomy[]): string | undefined => {
  const fontTags: CmsTaxonomy[] = subjectTaxonomyTags?.filter((tag): boolean => tag.startsWith(FONT_HEADING));

  return fontTags && fontTags.length > 0 ? fontTags[0] : undefined;
};
